import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  WorksessionReportModal,
  MemberRoleModal,
  DeactivateMemberModal,
  RemoveRoleModal,
  EditHourlyRateModal,
  AddDailyLimitModal,
  EmployeeIdModal,
} from '.';

const TeamKababMenu = ({
  userId,
  typeId,
  userRate,
  currency,
  totalProjects,
  typeName,
  customRole,
  employeeId,
}) => {
  const permissions = useSelector((state) => state.permissionsReducer);
  return (
    <Dropdown className="card-dropdown">
      <Dropdown.Toggle
        as={Link}
        to={{ hash: '#' }}
        className="project-kabab-menu dropdown-ellipses dropdown-toggle"
      >
        <i className="mdi mdi-dots-horizontal" />
      </Dropdown.Toggle>

      <Dropdown.Menu align="left">
        <>
          {permissions &&
            permissions.includes('work_session_edit') &&
            totalProjects > 0 && (
              <Dropdown.Item href={`/team/worksession/${userId}`}>
                Edit Worksession
              </Dropdown.Item>
            )}
          {permissions && permissions.includes('report_generate_csv') && (
            <WorksessionReportModal userId={userId} />
          )}
          {permissions &&
            permissions.includes('team_member_deactivate') &&
            typeName !== 'account owner' && (
              <DeactivateMemberModal userId={userId} />
            )}
          {permissions &&
            permissions.includes('team_member_promote') &&
            typeName !== 'account owner' && (
              <>
                {customRole && (
                  <RemoveRoleModal
                    userId={userId}
                    customRole={customRole}
                    typeId={typeId}
                  />
                )}
                <MemberRoleModal
                  userId={userId}
                  typeId={typeId}
                  typeName={typeName}
                />
              </>
            )}
          {permissions && permissions.includes('hourly_rate_manage') && (
            <EditHourlyRateModal
              userId={userId}
              userRate={userRate}
              currency={currency}
            />
          )}
          {permissions &&
            permissions.includes('work_session_daily_limit_update') && (
              <AddDailyLimitModal userId={userId} />
            )}
          <EmployeeIdModal userId={userId} employeeId={employeeId} />
        </>
      </Dropdown.Menu>
    </Dropdown>
  );
};

TeamKababMenu.propTypes = {
  userId: PropTypes.string,
  typeName: PropTypes.string,
  userRate: PropTypes.number,
  currency: PropTypes.string,
  typeId: PropTypes.string,
  totalProjects: PropTypes.number,
  customRole: PropTypes.string,
  employeeId: PropTypes.string,
};

export default TeamKababMenu;
